import ReportPrompt from "emun.report/report-params";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import config from "emun.report/report.config";

export default class ReportListController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$on("$blogSubmitted", () => $ctrl.query.load(true));
  }
  $onInit() {
    const $ctrl = this;

    $ctrl.query = new AutoQuery({
      url: "QueryReports.json?NameNotIn=SalesOrders_hkf050OrderBacklog",
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "DisplayName,Name",
      sortOptions: {
        "DisplayName,Name": "Name: A to Z",
        "-DisplayName,Name": "Name: Z to A"
      },
      autoLoad: true,
      onLoaded: function (args) {
        $ctrl.reporData = [];
        args.results.forEach(function (report) {
          if ($ctrl.$session.hasRole(report.roles.split(',')) || report.roles == '*') {
            $ctrl.reporData.push(report);
          }
          
        });

        $ctrl.reports = _.groupBy($ctrl.reporData, "group");
        //console.info("$ctrl.reports", $ctrl.reports);
        
      },
      pageSize: 1000
    });
  }
  load() {
    const $ctrl = this;
    $ctrl.query.load(true);
  }
  view(report) {
    const $ctrl = this;
    var reportConfigs = config.reports.filter(
      m => m.name.toUpperCase() == report.name.toUpperCase()
    );
    if (reportConfigs.length) {
      if (reportConfigs[0].url) {
        window.location = reportConfigs[0].url;
      } else {
        ReportPrompt({ report }).then(() => $ctrl.load());
      }
    }
  }
}
